import React from 'react';

interface CustomButtonInterface extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    color: string;
}
const Btn = React.forwardRef<HTMLButtonElement, CustomButtonInterface>(
    (props, ref)=> {
        const { color="", ...rest } = props;

        rest.className = rest.className ?? ""
        rest.className += ` btn-${color}`

        return <button { ...rest } role={'button'}></button>
    }
)

export default Btn;

